import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapProjects = {
  show: async(props) => {
    const { default: MlapDashboard } = await import('@/vue_widgets/mlap/dashboard/index.vue')
    createVueApp(MlapDashboard, { props })
  }
}
